import React from 'react';
import MetaData from '../layout/MetaData';

const Suspended = () => (
  <>
    <MetaData title="Account Suspended" />
    <div className="row wrapper">
      <div className="col-10 col-lg-6">
        <div className="card p-5 text-center">
          <i className="bi bi-exclamation-triangle-fill display-1 text-warning mb-4" />
          <h2 className="mb-4 text-danger">Account Suspended</h2>
          <p className="text-muted mb-4">
            Your account has been suspended because you have not cleared your dues as a driver to MBZ or have been involved in activities that violate MBZ Transport's policies.
          </p>
          <p className="mb-4">To reactivate your account and clear outstanding payments, please contact support.</p>
          <div className="alert alert-info">
            <strong>Support Helpline:</strong> <a href="tel:+923378233366" className="text-decoration-none">0337 8233366</a>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Suspended;